module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel02_1280_1280_vi-d2d830f1470a57d242ea3f483ae92f6c.jpg";